/*
 * @Author: qianyl
 * @Descripttion: 
 * @Date: 2024-11-22 16:01:27
 * @LastEditors: qianyl
 * @LastEditTime: 2025-07-09 13:39:28
 * @FilePath: \lesson-web-cms\src\api\ztSelectUser.ts
 */
import axios from '@/axios/index'

const baseUrl = '/page/login'
const URLS = {
  usrInfo: baseUrl + '/api/cen/oauth2/moreUser.do',
  loginSelf: baseUrl + '/api/cen/oauth2/loginSelf.do',
  moreUserLogin: baseUrl + "/api/cen/oauth2/moreUserLogin.do",
  authoLogin: baseUrl + '/api/cen/oauth2/authoLogin.do'
}

export const getMoreUserInfo = (token: string) => {
  return axios.get(URLS.usrInfo + '?data=' + token)
}

export const getLoginSelf = (params: {userId: string, orgType: string}) => {
  return axios.get(URLS.loginSelf + `?data=${params?.userId}&orgType=${params?.orgType}`)
}

export const getAuthoLogin = (params: {code: string}) => {
  return axios.get(URLS.authoLogin + `?code=${params?.code}`)
}

export const getMoreUserLogin = () => {
  return axios.get(URLS.moreUserLogin)
}